import { Box, Divider, styled, Typography } from '@mui/material';
import React from 'react';

const CuztomBox = styled(Box)(() => ({
  display: 'grid',
  gap: '10px',
  gridTemplateColumns: '70px 1fr'
}));

function CardDetail({ envioDetalle, persona = 'remitente', title = '' }) {
  const { city, street, zipcode, name, email, phone, colonia, exterior_number, interior_number } = envioDetalle;
  return (
    <Box>
      <Typography variant="subtitle1">{title}</Typography>
      <Divider />
      <Box>
        {' '}
        <CuztomBox>
          <Typography variant="subtitle2">Nombre:</Typography>
          <Typography fontSize="15px">{name}</Typography>
        </CuztomBox>{' '}
        <CuztomBox>
          <Typography variant="subtitle2">Calle:</Typography>
          <Typography fontSize="15px">
            {street} {exterior_number} {interior_number}
          </Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle2">Colonia:</Typography>
          <Typography fontSize="15px">{colonia}</Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle2">Ciudad:</Typography>
          <Typography fontSize="15px">{city}</Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle2">C.p:</Typography>
          <Typography fontSize="15px">{zipcode}</Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle2">Telefono:</Typography>
          <Typography fontSize="15px">{phone}</Typography>
        </CuztomBox>
        <CuztomBox>
          <Typography variant="subtitle2">Email:</Typography>
          <Typography fontSize="15px">{email}</Typography>
        </CuztomBox>
      </Box>
    </Box>
  );
}

export default CardDetail;
